<template>
<div class="chapter">
<div class="inner_page">
<h1 id="pgepubid00000">HOMAGE TO<br class="calibre10"/>
JOHN DRYDEN</h1>
<h2 class="sigil_not_in_toc" id="pgepubid00002">T. S. ELIOT</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?e5a350be